'use client';

import { useEffect, useState } from 'react';

import { subscribeToMyMessageReactions } from '../functions/reactions/subscribeToMyMessageReactions';

/**
 * Returns the set of `emojiCode`s the current user has reacted with
 * on a given message — driven by a Firestore subscription so the
 * "this is my reaction" highlight flips live as the user toggles
 * across tabs/devices.
 *
 * Returns an empty Set while auth is restoring or any of the inputs
 * is null/undefined.
 */
export function useMyMessageReactions(
  creatorId: string | null | undefined,
  channelId: string | null | undefined,
  messageId: string | null | undefined,
  userId: string | null | undefined,
): Set<string> {
  const [codes, setCodes] = useState<Set<string>>(() => new Set());

  useEffect(() => {
    if (!creatorId || !channelId || !messageId || !userId) {
      setCodes(new Set());
      return;
    }
    return subscribeToMyMessageReactions(
      creatorId,
      channelId,
      messageId,
      userId,
      setCodes,
    );
  }, [creatorId, channelId, messageId, userId]);

  return codes;
}
